import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const SortableHeader = ({ label, sortKey, currentSort, onSort, className, align = 'left' }) => {
    const isActive = currentSort && currentSort.key === sortKey;
    const direction = isActive ? currentSort.direction : null;

    return (
        <th
            className={twMerge(clsx(
                "bg-black/60 backdrop-blur-md text-stone-500 text-xs uppercase font-semibold px-4 py-3 border-b border-white/5 cursor-pointer hover:bg-white/5 hover:text-stone-300 transition-colors select-none group",
                align === 'center' && "text-center",
                align === 'right' && "text-right",
                className
            ))}
            onClick={() => onSort(sortKey)}
        >
            <div className={clsx("flex items-center gap-2",
                align === 'center' && "justify-center",
                align === 'right' && "justify-end"
            )}>
                <span>{label}</span>
                <span className="text-stone-600 group-hover:text-stone-400">
                    {direction === 'ascending' && <ArrowUp size={14} />}
                    {direction === 'descending' && <ArrowDown size={14} />}
                    {!direction && <ArrowUpDown size={14} className="opacity-0 group-hover:opacity-50" />}
                </span>
            </div>
        </th>
    );
};
